import * as yup from 'yup';

import i18n from '../../../../i18n/configs';

const requiredValidation = yup
  .string()
  .required(i18n.t('validation.error.required'));

const checkboxValidate = function (value: boolean[]): boolean {
  return value.includes(true);
};

const today = new Date();
today.setHours(0, 0, 0, 0);

export const inquirySchema = yup.object().shape({
  category: yup
    .number()
    .required(i18n.t('validation.error.required'))
    .oneOf([1, 2, 3, 4], i18n.t('validation.error.required')),
  issue: yup.string().required(i18n.t('validation.error.required')),
  message: requiredValidation.max(2000, i18n.t('validation.error.below2000'))
});

export const issueLikeSchema = yup.object().shape({
  media: yup.string().required(i18n.t('validation.error.required')),
  message: requiredValidation.max(2000, i18n.t('validation.error.below2000'))
});

export const orderSchema = yup.object().shape({
  amount: yup
    .number()
    .min(0, i18n.t('validation.error.above1'))
    .max(10000000000, i18n.t('validation.error.below10000000000'))
    .typeError(i18n.t('validation.error.number'))
    .required(i18n.t('validation.error.required')),
  companyName: requiredValidation.max(250, i18n.t('validation.error.below250')),
  compensation: yup
    .array()
    .test(
      'checkboxValidate',
      i18n.t('validation.error.atLeastOneOf'),
      (value) => checkboxValidate(value as boolean[])
    ),
  depositTiming: requiredValidation.max(
    250,
    i18n.t('validation.error.below250')
  ),
  kpi: requiredValidation.max(250, i18n.t('validation.error.below250')),
  optionContent: yup.string().when('optionFlg', {
    is: true,
    otherwise: yup.string().nullable(true).notRequired(),
    then: yup
      .string()
      .required(i18n.t('validation.error.required'))
      .max(250, i18n.t('validation.error.below250'))
  }),
  optionFlg: yup
    .bool()
    .required(i18n.t('validation.error.required'))
    .oneOf([true, false], i18n.t('validation.error.required')),
  pkgName: requiredValidation.max(250, i18n.t('validation.error.below250')),
  publishEndDate: yup
    .date()
    .typeError(i18n.t('validation.error.date'))
    .nullable()
    .transform((value, originalValue): void =>
      String(originalValue).trim() === '' ? null : value
    )
    .min(today, i18n.t('validation.error.dateMinToday'))
    .when('publishStartDate', (st: Date) => {
      if (st) {
        return yup
          .date()
          .typeError(i18n.t('validation.error.date'))
          .nullable()
          .min(st, i18n.t('validation.error.dateMin'));
      }
      return yup
        .date()
        .typeError(i18n.t('validation.error.date'))
        .nullable()
        .min(today, i18n.t('validation.error.dateMinToday'));
    }),
  publishStartDate: yup
    .date()
    .typeError(i18n.t('validation.error.date'))
    .nullable()
    .transform((value, originalValue): void =>
      String(originalValue).trim() === '' ? null : value
    )
    .min(today, i18n.t('validation.error.dateMinToday')),
  reportFlg: yup
    .bool()
    .required(i18n.t('validation.error.required'))
    .oneOf([true, false], i18n.t('validation.error.required')),
  reportSubmissionDate: yup
    .date()
    .typeError(i18n.t('validation.error.date'))
    .transform((value, originalValue): void =>
      String(originalValue).trim() === '' ? null : value
    )
    .min(today, i18n.t('validation.error.dateMinToday'))
    .when('reportFlg', {
      is: true,
      otherwise: yup.date().nullable().notRequired(),
      then: yup
        .date()
        .typeError(i18n.t('validation.error.date'))
        .required(i18n.t('validation.error.required'))
    }),
  transferTiming: yup
    .bool()
    .required(i18n.t('validation.error.required'))
    .oneOf([true, false], i18n.t('validation.error.required'))
});

export const declineCaseSchema = yup.object().shape({
  cause: yup
    .array()
    .test(
      'checkboxValidate',
      i18n.t('validation.error.atLeastOneOf'),
      (value) => checkboxValidate(value as boolean[])
    ),
  comment: yup.string().max(2000, i18n.t('validation.error.below2000'))
});
